<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import CheckModal from "@/components/CheckModal";
import DocumentActions from "@/components/document/DocumentActions.vue";
import PhotoEvidence from "@/components/standard/PhotoEvidence";
import riskMatrixAPI from "@/services/standards/riskMatrix/riskMatrixAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import newScoresAPI from "@/services/newScores/newScoresAPI";
import Swal from "sweetalert2";

function blankRow() {
  return {
    proceso: "", zona: "", actividad: "", tarea: "", rutinaria: "SI",
    peligro_clasificacion: null, peligro_descripcion: null, efectos_posibles: "",
    control_fuente: "", control_medio: "", control_individuo: "",
    nivel_deficiencia: null, nivel_exposicion: null, nivel_consecuencia: null,
    nro_expuestos: null, peor_consecuencia: "",
    med_eliminacion: "", med_sustitucion: "", med_ingenieria: "", med_administrativos: "", med_epp: "",
  };
}

export default {
  page: { title: "Matriz de Riesgos IPEVR" },
  components: { Layout, PageHeader, CheckModal, DocumentActions, PhotoEvidence },
  data() {
    return {
      title: "4.1.2 Matriz de Riesgos IPEVR (GTC-45)",
      items: [
        { text: "Estándares", href: "/forms/estandares" },
        { text: "4.1.2 Matriz de Riesgos", active: true },
      ],
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      matrixId: this.$route.params.matrix || null,
      catalog: { hazards: {}, nd: [], ne: [], nc: [], rutinaria: ["SI", "NO"] },
      form: { version: "1.0", fecha: new Date().toISOString().substring(0, 10), observacion: null },
      rows: [blankRow()],
      evidence: [],
      evFile: null,
      evDescripcion: null,
      uploadingEv: false,
      workflowStatus: "draft",
      signedAt: null,
      submitting: false,
      loading: true,
    };
  },
  computed: {
    isSigned() {
      return this.workflowStatus === "signed";
    },
    clasificaciones() {
      return Object.keys(this.catalog.hazards || {});
    },
    riskMatrixApi() {
      return {
        pdfUrl: (id) => riskMatrixAPI.pdfUrl(id),
        sign: (id, payload) => riskMatrixAPI.sign(id, payload),
      };
    },
    resumen() {
      const r = { I: 0, II: 0, III: 0, IV: 0 };
      this.rows.forEach((row) => { r[this.compute(row).lvl]++; });
      return r;
    },
  },
  methods: {
    goBack() { this.$router.go(-1); },
    descripciones(clasif) {
      return (this.catalog.hazards && this.catalog.hazards[clasif]) || [];
    },
    onClasifChange(row) {
      row.peligro_descripcion = null;
    },
    compute(row) {
      const nd = Number(row.nivel_deficiencia) || 0;
      const ne = Number(row.nivel_exposicion) || 0;
      const nc = Number(row.nivel_consecuencia) || 0;
      const np = nd * ne;
      let npInt = "Bajo";
      if (np >= 24) npInt = "Muy Alto"; else if (np >= 10) npInt = "Alto"; else if (np >= 6) npInt = "Medio";
      const nr = np * nc;
      let lvl, acc;
      if (nr >= 600) { lvl = "I"; acc = "No Aceptable"; }
      else if (nr >= 150) { lvl = "II"; acc = "No Aceptable o Aceptable con control específico"; }
      else if (nr >= 40) { lvl = "III"; acc = "Aceptable"; }
      else { lvl = "IV"; acc = "Aceptable"; }
      return { np, npInt, nr, lvl, acc };
    },
    nivelClass(lvl) {
      return { I: "badge-danger", II: "badge-warning", III: "badge-warning", IV: "badge-success" }[lvl] || "badge-secondary";
    },
    addRow() { if (!this.isSigned) this.rows.push(blankRow()); },
    removeRow(idx) {
      if (this.isSigned) return;
      this.rows.splice(idx, 1);
      if (!this.rows.length) this.rows.push(blankRow());
    },
    load() {
      if (!this.matrixId) { this.loading = false; return; }
      riskMatrixAPI.get(this.matrixId)
        .then((r) => {
          if (!r) { this.loading = false; return; }
          this.form.version = r.version || "1.0";
          this.form.fecha = r.fecha ? String(r.fecha).substring(0, 10) : this.form.fecha;
          this.form.observacion = r.observacion || null;
          this.rows = (r.rows && r.rows.length)
            ? r.rows.map((x) => ({ ...blankRow(), ...x }))
            : [blankRow()];
          this.evidence = r.evidence || [];
          this.workflowStatus = r.workflow_status || "draft";
          this.signedAt = r.signed_at || null;
          this.loading = false;
        })
        .catch((e) => { console.log(e); this.loading = false; });
    },
    save() {
      if (this.isSigned) return;
      this.submitting = true;
      const payload = { companies_id: this.companyID, ...this.form, rows: this.rows };
      const req = this.matrixId ? riskMatrixAPI.update(this.matrixId, payload) : riskMatrixAPI.save(payload);
      req
        .then((res) => {
          newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 42, status: "Pendiente" }).catch(() => {});
          Swal.fire({ title: "¡Éxito!", text: "Matriz guardada.", icon: "success", timer: 1600, showConfirmButton: false });
          this.submitting = false;
          if (!this.matrixId && res && res.id) {
            this.matrixId = res.id;
            this.$router.replace({ path: `/forms/estandares/${this.companyID}/matriz-riesgos/${res.id}` });
          }
        })
        .catch((e) => { console.log(e); this.submitting = false; Swal.fire("Error", "No se pudo guardar la matriz", "error"); });
    },
    onEvFile() { this.evFile = this.$refs.evFile.files[0]; },
    async addEvidence() {
      if (!this.matrixId) { Swal.fire("Atención", "Guarda la matriz antes de cargar evidencias.", "info"); return; }
      if (!this.evFile) { Swal.fire("Atención", "Selecciona un archivo.", "info"); return; }
      this.uploadingEv = true;
      try {
        const base = process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
        const path = `${base}/${this.nit}/4.1.2/evidencias/${this.matrixId}/${Date.now()}_${this.evFile.name}`;
        const ok = await uploadDocument(path, this.evFile);
        if (!ok) throw new Error("upload");
        const fileUrl = `${process.env.VUE_APP_BUCKET}/${path}`;
        const res = await riskMatrixAPI.addEvidence(this.matrixId, { file: fileUrl, descripcion: this.evDescripcion });
        this.evidence.push({ id: res.id, file: fileUrl, descripcion: this.evDescripcion });
        this.evFile = null; this.evDescripcion = null;
        if (this.$refs.evFile) this.$refs.evFile.value = null;
        Swal.fire({ title: "Evidencia cargada", icon: "success", timer: 1300, showConfirmButton: false });
      } catch (e) {
        console.log(e);
        Swal.fire("Error", "No se pudo cargar la evidencia", "error");
      } finally {
        this.uploadingEv = false;
      }
    },
    removeEvidence(ev, idx) {
      riskMatrixAPI.deleteEvidence(ev.id)
        .then(() => { this.evidence.splice(idx, 1); })
        .catch((e) => { console.log(e); Swal.fire("Error", "No se pudo eliminar", "error"); });
    },
    fileName(url) { return String(url).split("/").pop(); },
    onSigned(payload) {
      this.workflowStatus = payload.workflow_status;
      this.signedAt = payload.signed_at;
    },
  },
  mounted() {
    riskMatrixAPI.catalog().then((c) => { if (c) this.catalog = c; });
    this.load();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-9" v-if="!loading">
        <div class="card">
          <div class="card-body">
            <CheckModal>
              <p class="text-justify">
                Edita la matriz de identificación de peligros y valoración de riesgos (IPEVR, metodología GTC-45)
                directamente en línea. Por cada peligro elige el Nivel de Deficiencia, Exposición y Consecuencia, y la
                plataforma calcula automáticamente el Nivel de Probabilidad, el Nivel de Riesgo y la Aceptabilidad. Cada
                guardado es una versión; puedes cargar evidencias de la participación de los colaboradores y firmar la matriz.
              </p>
            </CheckModal>

            <div v-if="isSigned" class="alert alert-success py-2 my-2 small">
              🔒 Esta versión ya fue firmada; los datos quedan bloqueados. Usa "Nueva versión" en el listado para crear una revisión editable.
            </div>

            <form @submit.prevent="save">
              <div class="form-row">
                <b-form-group class="col-md-2 px-2" label="Versión">
                  <b-form-input type="text" v-model="form.version" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-3 px-2" label="Fecha">
                  <b-form-input type="date" v-model="form.fecha" :disabled="isSigned" required />
                </b-form-group>
                <b-form-group class="col-md-7 px-2" label="Observación / metodología">
                  <b-form-input type="text" v-model="form.observacion" :disabled="isSigned" />
                </b-form-group>
              </div>

              <div class="d-flex justify-content-between align-items-center mt-2">
                <h5 class="mb-0">Peligros identificados</h5>
                <span class="small">
                  <span class="badge badge-danger">I: {{ resumen.I }}</span>
                  <span class="badge badge-warning">II: {{ resumen.II }}</span>
                  <span class="badge badge-warning">III: {{ resumen.III }}</span>
                  <span class="badge badge-success">IV: {{ resumen.IV }}</span>
                </span>
              </div>

              <div v-for="(row, idx) in rows" :key="idx" class="border rounded p-2 mb-3">
                <div class="d-flex justify-content-between">
                  <strong class="small text-primary">Peligro #{{ idx + 1 }}</strong>
                  <button type="button" class="btn btn-outline-danger btn-sm py-0" :disabled="isSigned" @click="removeRow(idx)">
                    <i class="mdi mdi-trash-can"></i>
                  </button>
                </div>
                <div class="form-row">
                  <b-form-group class="col-md-3 px-2" label="Proceso"><b-form-input v-model="row.proceso" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-2 px-2" label="Zona/Lugar"><b-form-input v-model="row.zona" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Actividad"><b-form-input v-model="row.actividad" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Tarea"><b-form-input v-model="row.tarea" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-1 px-2" label="Rut.">
                    <b-form-select v-model="row.rutinaria" :options="catalog.rutinaria" :disabled="isSigned" size="sm" />
                  </b-form-group>
                </div>
                <div class="form-row">
                  <b-form-group class="col-md-3 px-2" label="Clasificación del peligro">
                    <b-form-select v-model="row.peligro_clasificacion" :disabled="isSigned" size="sm" @change="onClasifChange(row)">
                      <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                      <b-form-select-option v-for="c in clasificaciones" :key="c" :value="c">{{ c }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group class="col-md-5 px-2" label="Descripción del peligro">
                    <b-form-select v-model="row.peligro_descripcion" :disabled="isSigned || !row.peligro_clasificacion" size="sm">
                      <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                      <b-form-select-option v-for="d in descripciones(row.peligro_clasificacion)" :key="d" :value="d">{{ d }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Efectos posibles"><b-form-input v-model="row.efectos_posibles" :disabled="isSigned" size="sm" /></b-form-group>
                </div>
                <div class="form-row">
                  <b-form-group class="col-md-4 px-2" label="Control existente — Fuente"><b-form-input v-model="row.control_fuente" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Medio"><b-form-input v-model="row.control_medio" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Individuo"><b-form-input v-model="row.control_individuo" :disabled="isSigned" size="sm" /></b-form-group>
                </div>
                <div class="form-row align-items-end bg-light rounded py-1">
                  <b-form-group class="col-md-2 px-2" label="N. Deficiencia">
                    <b-form-select v-model="row.nivel_deficiencia" :disabled="isSigned" size="sm">
                      <b-form-select-option :value="null">—</b-form-select-option>
                      <b-form-select-option v-for="o in catalog.nd" :key="o.value" :value="o.value">{{ o.label }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group class="col-md-2 px-2" label="N. Exposición">
                    <b-form-select v-model="row.nivel_exposicion" :disabled="isSigned" size="sm">
                      <b-form-select-option :value="null">—</b-form-select-option>
                      <b-form-select-option v-for="o in catalog.ne" :key="o.value" :value="o.value">{{ o.label }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group class="col-md-2 px-2" label="N. Consecuencia">
                    <b-form-select v-model="row.nivel_consecuencia" :disabled="isSigned" size="sm">
                      <b-form-select-option :value="null">—</b-form-select-option>
                      <b-form-select-option v-for="o in catalog.nc" :key="o.value" :value="o.value">{{ o.label }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <div class="col-md-5 px-2 pb-2 small">
                    <span class="mr-2">NP: <strong>{{ compute(row).np }}</strong> ({{ compute(row).npInt }})</span>
                    <span class="mr-2">NR: <strong>{{ compute(row).nr }}</strong></span>
                    <span class="badge" :class="nivelClass(compute(row).lvl)">Nivel {{ compute(row).lvl }} — {{ compute(row).acc }}</span>
                  </div>
                  <b-form-group class="col-md-1 px-2" label="N° exp."><b-form-input type="number" min="0" v-model="row.nro_expuestos" :disabled="isSigned" size="sm" /></b-form-group>
                </div>
                <div class="form-row">
                  <b-form-group class="col-md-3 px-2" label="Med. Eliminación"><b-form-input v-model="row.med_eliminacion" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Sustitución"><b-form-input v-model="row.med_sustitucion" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-2 px-2" label="Ingeniería"><b-form-input v-model="row.med_ingenieria" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-2 px-2" label="Administrativos"><b-form-input v-model="row.med_administrativos" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-2 px-2" label="EPP"><b-form-input v-model="row.med_epp" :disabled="isSigned" size="sm" /></b-form-group>
                </div>
              </div>

              <button type="button" class="btn btn-outline-primary btn-sm mb-3" :disabled="isSigned" @click="addRow">
                <i class="mdi mdi-plus"></i> Agregar peligro
              </button>

              <div class="text-right">
                <button type="submit" :disabled="isSigned || submitting" class="btn btn-primary mx-1">Guardar</button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
              </div>
            </form>

            <!-- Evidencias de participación -->
            <hr />
            <h5>Evidencias de participación de los colaboradores</h5>
            <p class="text-muted small">Carga actas, encuestas, registros fotográficos, etc. (cualquier tipo de archivo).</p>
            <div v-if="matrixId" class="form-row align-items-end">
              <b-form-group class="col-md-5 px-2" label="Descripción">
                <b-form-input v-model="evDescripcion" :disabled="isSigned" size="sm" placeholder="Ej: Acta de participación COPASST" />
              </b-form-group>
              <b-form-group class="col-md-5 px-2" label="Archivo">
                <b-form-file ref="evFile" v-model="evFile" :disabled="isSigned" browse-text="Buscar"
                  placeholder="Selecciona un archivo..." @change="onEvFile" size="sm" />
              </b-form-group>
              <div class="col-md-2 px-2 pb-2">
                <button type="button" class="btn btn-primary btn-sm btn-block" :disabled="isSigned || uploadingEv" @click="addEvidence">
                  {{ uploadingEv ? 'Subiendo...' : 'Cargar' }}
                </button>
              </div>
            </div>
            <div v-else class="alert alert-info py-2 small">Guarda la matriz para habilitar el cargue de evidencias.</div>

            <ul class="list-group">
              <li v-for="(ev, idx) in evidence" :key="ev.id" class="list-group-item d-flex justify-content-between align-items-center py-2">
                <span class="small"><i class="mdi mdi-paperclip"></i> {{ ev.descripcion || fileName(ev.file) }}</span>
                <span>
                  <a :href="ev.file" target="_blank" class="btn btn-light btn-sm py-0"><i class="mdi mdi-cloud-download"></i></a>
                  <button v-if="!isSigned" type="button" class="btn btn-outline-danger btn-sm py-0" @click="removeEvidence(ev, idx)"><i class="mdi mdi-trash-can"></i></button>
                </span>
              </li>
              <li v-if="!evidence.length" class="list-group-item text-muted small">Sin evidencias cargadas.</li>
            </ul>

            <!-- Registro fotográfico de socialización (se incrusta como anexo en el PDF) -->
            <div class="mt-3" v-if="matrixId">
              <PhotoEvidence
                :company-id="companyID"
                item-code="4.1.2"
                reference-type="risk_matrix"
                :reference-id="matrixId"
                category="socializacion"
                :disabled="isSigned"
                title="Registro fotográfico de socialización"
                help-text="Fotos de la socialización/divulgación de la matriz a los colaboradores. Se incluyen como anexo en el PDF firmado."
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3" v-if="!loading && matrixId">
        <h6 class="text-muted small mb-1">Matriz de Riesgos IPEVR</h6>
        <DocumentActions
          :document-id="Number(matrixId)"
          :company-id="companyID"
          :workflow-status="workflowStatus"
          :signed-at="signedAt"
          :api-service="riskMatrixApi"
          document-title="Matriz de Riesgos IPEVR"
          signer-role="gerente"
          @signed="onSigned"
        />
      </div>

      <div v-if="loading" class="col-12 text-center"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
    </div>
  </Layout>
</template>
